import { forwardRef } from 'react';

export const SelectInputField = forwardRef(
  (
    {
      label,
      error,
      extraClasses = '',
      options = [],
      placeholder = '',
      paddingLeft = 'md',
      paddingRight = 'md',
      RenderOption = ({ item }) => (
        <option value={item?.value}>{item?.label}</option>
      ),
      height = '36',
      disabled = false,
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';
    return (
      <div className="w--full d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <select
          ref={ref}
          {...rest}
          className={`form--control w--full h-min--${height} radius--sm p-l--${paddingLeft} p-r--${paddingRight} ${extraClasses} ${
            error ? 'border-full--danger' : 'border-full--black-200'
          }`}
          disabled={disabled}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options &&
            options.length > 0 &&
            options.map((item, index) => (
              <RenderOption key={index} item={item} />
            ))}
        </select>
      </div>
    );
  },
);
